module.exports = __webpack_public_path__ + "img/AL802-1.63a585b5.jpg";